import { useEffect, useState } from "react";
import { MD5 } from 'crypto-js';
import { URL, LOGIN, UPPASSMAIL } from './paths';
import { fetchData } from '../hooks/fetch/const_fetch';
import { getUserID, getUserName } from "./datainfo/dto";
import Iconos from "./iconos/iconos";
import './ChangePassMail.css'
import Loader from "./loader/loader";
import CerrarSesion from "./datainfo/del_dto";
import { Modal } from "react-bootstrap";

export default function ChangePassMail({userMail, onClose}) {
    const [isLoading, setLoading] = useState(false);
    const [disabledSave, setDisabledSave] = useState(false);
    const [show, setShow] = useState(true);
    
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [actualPassword, setActualPassword] = useState("");
    const [nuevaPassword, setNuevaPassword] = useState("");
    const [confirmarPassword, setConfirmarPassword] = useState("");

    const [validEmail, setValidEmail] = useState("");
    const [validPhone, setValidPhone] = useState("");
    const [validPActual, setValidPActual] = useState("");
    const [validPNueva, setValidPNueva] = useState("");
    const [validPConfir, setValidPConfir] = useState("");
    
    const [seePActual, setSeePActual] = useState(false);
    const [seePNueva, setSeePNueva] = useState(false);
    const [seePConfir, setSeePConfir] = useState(false);

    const [msgerr,setMsgErr] = useState("");

    useEffect(()=>{ 
        //console.log("userMail Login",userMail)
        if(userMail !== ""){
            setEmail(userMail)
        }
    },[])

    const iniciarSesion = async () =>{                  
        const myHeaders = new Headers();
        myHeaders.append("Content-Type",  'application/json'); 
        
        let auxPass = MD5(actualPassword).toString().toUpperCase()
        let dtos = { "strUserName": getUserName(),  strUserPassword: auxPass }
        //console.log("paramsLogin",dtos)
        let loginAux = await fetchData(URL + LOGIN, 'POST', myHeaders, dtos);
        //console.log("Login",loginAux)
        if (loginAux) {
            switch (loginAux.code) {
                case 0:
                    setMsgErr("Contraseña actual incorrecta"); 
                    setLoading(false);
                    break;
                case 1:
                    setMsgErr("")
                    getCambiarPassword()                                     
                    break;
                default:
                    setMsgErr(loginAux.msg)
                    setLoading(false);
                    break;
            }
        }
    }

    const getCambiarPassword = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type",  'application/json'); 
        
        let passwordActualAux = MD5(actualPassword).toString().toUpperCase();
        let passwordNuevaAux = MD5(nuevaPassword).toString().toUpperCase();
        let params = { 
            "strUserName": getUserName(),
            "strUserEmail": email,
            "strUserPhone": telefono,
            "strUserPasswordOld": passwordActualAux, 
            "strUserPasswordNew": passwordNuevaAux, 
            "intUserId": getUserID() 
        }
        //console.log("params: ",params)
        let loginAux = await fetchData(URL + UPPASSMAIL, 'POST', myHeaders, params);
        //console.log("loginAux: ",loginAux)
        if (loginAux) {
            switch (loginAux.code) {
                case 0:
                    CerrarSesion()
                    alert("Contraseña cambiada exitosamente.\n\nVolver a iniciar sesión");
                    window.location.assign('/home');
                    break;
                default:
                    alert(loginAux.msg)
                    break;
            }
        }
        setLoading(false);
    }

    const handleCambiar = (e) => {
        e.preventDefault();
        const setData2 = async () => {
            iniciarSesion()
        }

        if(email.trim().length < 5){
            setValidEmail("is-invalid")
            setMsgErr("Se debe ingresar el email")
            return
        }else{
            setValidEmail("")
            setMsgErr("")
        }
        
        if(telefono.trim().length < 10){
            setValidPhone("is-invalid")
            setMsgErr("Se debe ingresar el teléfono (10 digitos)")
            return
        }else{
            setValidPhone("")
            setMsgErr("")
        }

        if(actualPassword.trim().length == 0 ){
            setValidPActual("is-invalid")
            setMsgErr("Se debe ingresar contraseña actual")
            return
        }else{
            setValidPActual("")
            setMsgErr("")
        }

        if(nuevaPassword !== confirmarPassword){
            setValidPConfir("is-invalid")
            setMsgErr("Las contraseñas no coinciden")
            return
        }else{
            setValidPNueva("")
            setValidPConfir("")
        }

        if(nuevaPassword.trim().length < 8){
            setValidPNueva("is-invalid")
            setValidPConfir("is-invalid")
            setMsgErr("La contraseña debe de tener 8 caracteres o más")
            return
        }else{
            setValidPNueva("")
            setValidPConfir("")
        }
        const validacion = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
        
        if(!validacion.test(nuevaPassword)){
            setValidPNueva("is-invalid")
            setValidPConfir("is-invalid")
            setMsgErr("Se debe incluir una letra mayúscula, minúscula, número y carácter especial.");
            return
        }else{
            setValidPNueva("")
            setValidPConfir("")
        }
        setLoading(true);
        setData2()/**/
    }

    const handleActualPassword = (e) => {
        setActualPassword(e.target.value)
    }

    const handleNuevaPassword = (e) =>  {
        setValidPNueva("")
        const value= e.target.value;
        const validacion = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
        if(validacion.test(value)){
            setMsgErr("");
        }else{
            setMsgErr("Se debe incluir una letra mayúscula, minúscula, número y carácter especial.");
        }
        setNuevaPassword(value)
    }

    const handleConfirmarPassword = (e) =>  {
        setConfirmarPassword(e.target.value)
    }
    
    const handleEmail = (e) =>  {
        setEmail(e.target.value)
        console.log(e.target.value)
    }
    
    const handleTelefono = (e) =>  {
        setTelefono(e.target.value)
    }

    const modalClose = () => {
        setShow(false);
        if(onClose) onClose() 
    };

  return (
    <>
        <Modal
        show={show}
        onHide={modalClose}
        backdrop="static"
        size="m"
        centered
        >        
            <div className="">
                <Modal.Header  >
                    <Modal.Title className="title_password">Cambio de contraseña</Modal.Title>
                </Modal.Header>
                { isLoading && <Loader/>}
                <div className="maxWidthContra">

                    <div className=" divContraAviso">
                        <span className="contra_aviso">Se debe cambiar la contraseña actual, verificar el email y número telefónico.{``}</span>
                        <br></br>
                        <span className="contra_aviso text_size">La nueva contraseña debe incluir una letra mayúscula, minúscula, número y carácter especial.</span>

                    </div>

                    
                    <div className="divNuevacontra">
                        <span className="contra_text">Email:</span>                
                        <input
                            type="email"
                            className={`form-control col-12 mb-2 ${validEmail} `}
                            placeholder="nombre@ejemplo.com"
                            required
                            value={email}
                            onChange={handleEmail}
                        />

                    </div>

                    <div className="divNuevacontra">
                        <span className="contra_text">Teléfono:</span>
                        <input
                            type="tel"
                            className={`form-control col-12 mb-2 ${validPhone} `}
                            placeholder="1234567890"
                            maxLength={10}
                            required
                            value={telefono}
                            onChange={handleTelefono}
                        />

                    </div>
                    
                    <div className="divNuevacontra">
                        <span className="contra_text">Contraseña actual:</span>
                        <br/>
                        <div className="lineContraEye">
                            <input
                                type={seePActual? "text ":"password"}
                                className={`form-control col-12 mb-2 ${validPActual} `}
                                required
                                value={actualPassword}
                                onChange={handleActualPassword}
                            />
                            <button className="eyeButton" type="button" onClick={() => {setSeePActual(!seePActual)}}>
                                <Iconos icono={seePActual ? "EYE_OPEN" : "EYE_CLOSED"}  width={"20px"} height={"20px"} fill="#04376b"/> 
                            </button>
                            
                        </div>

                    </div>           

                    <div className="divNuevacontra">
                        <span className="contra_text">Nueva contraseña:</span>
                        <div className="lineContraEye">
                            <input
                                type={seePNueva? "text ":"password"}
                                className={`form-control col-12 mb-2 ${validPNueva} `}
                                minlength="8"
                                required
                                value={nuevaPassword}
                                onChange={handleNuevaPassword}
                            />
                            <button className="eyeButton" type="button" onClick={() => {setSeePNueva(!seePNueva)}}>
                                <Iconos icono={seePNueva ? "EYE_OPEN" : "EYE_CLOSED"}  width={"20px"} height={"20px"} fill="#04376b"/> 
                            </button>
                        </div>

                    </div>

                    <div className="divNuevacontra">
                        <span className="contra_text">Confirmar contraseña:</span>
                        <div className="lineContraEye">
                            <input
                                type={seePConfir? "text ":"password"}
                                className={`form-control col-12 mb-2 ${validPConfir} `}
                                minlength="8"
                                required
                                value={confirmarPassword}
                                onChange={handleConfirmarPassword}
                            />
                            <button className="eyeButton" type="button" onClick={() => {setSeePConfir(!seePConfir)}}>
                                <Iconos icono={seePConfir ? "EYE_OPEN" : "EYE_CLOSED"}  width={"20px"} height={"20px"} fill="#04376b"/> 
                            </button>
                        </div>
                    </div>

                    {msgerr &&
                        <div className="alert alert-danger hide">
                            {msgerr}
                        </div>
                    }  

                    
                    <div className="paddingTop10Px paddingBottom10Px divNuevacontra">
                        <button className="btn btn-primary fw-bold col-12" onClick={handleCambiar} disabled={disabledSave}>Guardar</button>
                    </div>

                </div>

            
            </div>
        </Modal>
    </>
  )
}
